import { isDefined, isObject } from '@tyler-components-web/core';
export var SelectOptionType;
(function (SelectOptionType) {
    SelectOptionType[SelectOptionType["Option"] = 0] = "Option";
    SelectOptionType[SelectOptionType["Group"] = 1] = "Group";
})(SelectOptionType || (SelectOptionType = {}));
/**
 * Determines if the provided options are of the specified type.
 * @param options The options either grouped or individual.
 * @param type The type of option to detect.
 */
export function isSelectOptionType(options, type) {
    var isOptionGroups = options.some(function (o) { return isOptionGroupObject(o); });
    var isOptionTypes = options.some(function (o) { return isOptionObject(o); });
    return (isOptionGroups && type === SelectOptionType.Group) || (isOptionTypes && type === SelectOptionType.Option);
}
export function isOptionGroupObject(o) {
    return isDefined(o) && isObject(o) && o.hasOwnProperty('options') && (o.hasOwnProperty('text'));
}
export function isOptionObject(o) {
    return isDefined(o) && isObject(o) && o.hasOwnProperty('label') && (o.hasOwnProperty('value'));
}
